import React, { Component } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import { ExcelRenderer } from "react-excel-renderer";
import ReactToExcel from "react-html-table-to-excel";
import UploadFileButton from "../../common/buttons/uploadFileButton";
import Helper from "./universe_lite/helper/Helper";
// import CustomTableTree from "./universe_lite/Analyze/customTreeTable";
// import Pannel from "../Create/universe/customTreeTable/pannel";
// import MultiRowPannel from "../Create/universe/customTreeTable/multiRowAddPannel";
import Spinner from "../../common/spinner";
import TablePannel from "../Create/universe_lite/Analyze/tablePannel";
import UniverseAnalyzeTreeTableHolder from "../Create/universe_lite/UniverseAnalyzeTreeTableHolder";
import "./Universe.Analyze.style.scss";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;

class UniverseAnalyze extends Component {
  state = {
    finalPortfolio: [],
    treeData: [],
    checkBoxSelectedList: [],
    resetOnChangeInput: false,

    pannelListOfDataAdded: {},
    pannelCheckBoxSelectedList: [],
    pannelSearchValue: "",
    autoCompleteData: [],
    showSearchField: false,
    pannel_fund_name: "",
    pannel_asset_class: "",
    pannel_classification: "",
    pannel_symbol: "",
    pannel_style: "",
    pannelAllocationValue: "",

    displayAutoCompleteOp: true,
    showPannelData: false,
    upload_errorName: "",
    spinner: false,
    showExcludedSecuritiesPannel: false,
    ExcludedSecurities: [],
    excludedSelectedList: [],
    wrongXLXSFormat: false,
  };
  async componentDidMount() {
    let {
      portfolio,
      myUniverse,
      overRideAllocation,
      analyze_merged_portfolio,
    } = this.props;

    // checking myUniverse data, if not there making api call
    if (myUniverse.length === 0) {
      this.setState({
        spinner: true,
      });
      await BacktestService.getMyUniverse()
        .then((res) => {
          if (res) {
            let myUniverse = res;
            this.props.setIQCIOliveMyUniverse(res);
            this.setData({ portfolio, myUniverse, overRideAllocation });

            this.setState({
              spinner: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            spinner: false,
          });
        });
    } else if (
      analyze_merged_portfolio &&
      analyze_merged_portfolio.length === 0
    ) {
      this.setData({ portfolio, myUniverse, overRideAllocation });
    }
  }

  componentWillReceiveProps(nextProps) {
    let {
      portfolio,
      myUniverse,
      overRideAllocation,
      analyze_merged_portfolio,
    } = nextProps;
    if (
      JSON.stringify(portfolio) !== JSON.stringify(this.props.portfolio) ||
      JSON.stringify(myUniverse) !== JSON.stringify(this.props.myUniverse)
    ) {
      this.setData({ portfolio, myUniverse, overRideAllocation });
    }

    if (
      JSON.stringify(this.props.analyze_merged_portfolio) !==
      JSON.stringify(analyze_merged_portfolio)
    ) {
      this.setLimitsData({ analyze_merged_portfolio });
    }
  }

  // after add new security to table list(analyze_merged_portfolio) - setting new limits data
  setLimitsData = ({ analyze_merged_portfolio }) => {
    if (!analyze_merged_portfolio) return;

    let modifiedBackendParams = Helper.getLimitsDataFromSymbols(
      analyze_merged_portfolio,
      20
    );
    this.props.setBackendParam_Analyze_Universe_limits(modifiedBackendParams);
  };
  //---------------------
  // data merging function
  setData = ({ portfolio, myUniverse, overRideAllocation }) => {
    const {
      setAnalyzeMergedData,
      setBackendParam_Analyze_Universe_limits,
      setExcludedSecurities,
    } = this.props;

    let modified_data = this.portfolioComparision({
      myPortfolio: portfolio,
      myUniverse,
      overRideAllocation,
    });

    this.setState({
      finalPortfolio: modified_data["data"],
    });
    setAnalyzeMergedData(modified_data["data"]);

    // setting excluded securities

    setExcludedSecurities(modified_data["excludeSecurities"]);

    //setting backend params data based on merged data
    // using this data in Limits step

    let modifiedBackendParams = Helper.getLimitsDataFromSymbols(
      modified_data["data"],
      20
    );
    setBackendParam_Analyze_Universe_limits(modifiedBackendParams);
  };

  portfolioComparision = ({ myPortfolio, myUniverse, overRideAllocation }) => {
    if (
      !myPortfolio &&
      !myPortfolio.length &&
      !myUniverse &&
      !myUniverse.length
    )
      return;
    // merging myUniverse data and uploaded securities data
    let obj = {};
    // original allocation ==> from uploaded portfolio
    // core_allocatin ==> from myUniverse

    let excluded = [];
    // excluded data
    // if uploaded data are not common to my universe , then saving in excluded

    for (let i = 0; i < myPortfolio.length; i++) {
      let temp = Object.assign(
        { original_allocation: myPortfolio[i]["val"] },
        { core_allocation: null },
        { merged: false },
        myPortfolio[i]
      );

      // checking this symbol present in myUniverse data
      let filter = myUniverse.filter(
        (e) => e.symbol.toUpperCase() === myPortfolio[i]["symbol"].toString().toUpperCase()
      );

      if (filter && filter.length > 0) {
        obj[myPortfolio[i]["symbol"]] = temp;
      } else {
        excluded.push(temp);
      }
    }
    for (let j = 0; j < myUniverse.length; j++) {
      // if overRideAllocation true myPortfolio value will be replaced by myUniverse
      if (myUniverse[j]["symbol"] in obj && overRideAllocation) {
        let newObject = Object.assign(
          { original_allocation: obj[myUniverse[j]["symbol"]]["val"] },
          { core_allocation: myUniverse[j]["val"] },
          { merged: true },
          myUniverse[j]
        );

        obj[myUniverse[j]["symbol"]] = newObject;
      } else if (myUniverse[j]["symbol"] in obj === false) {
        let newObject = Object.assign(
          { original_allocation: null },
          { core_allocation: myUniverse[j]["val"] },
          { merged: false },

          //in myUniverse key are used differently, changing here similar to myPortfolio
          { new_fund_type: myUniverse[j]["fund_type"] },
          { new_classification: myUniverse[j]["classification"] },
          { fund_asset_class_focus: myUniverse[j]["asset_class"] },
          { new_style: myUniverse[j]["style"] },

          myUniverse[j]
        );
        obj[myUniverse[j]["symbol"]] = newObject;
      } else {
        continue;
      }
    }
    return { data: Object.values(obj), excludeSecurities: excluded };
  };

  // xlsx handler

  xlsxHandler = (e, type) => {
    let file = e.target.files[0];
    if (
      file &&
      file.name &&
      (file.name.includes(".xls") || file.name.includes(".xlsx"))
    ) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error");
        } else {
          //remove empty arrays
          var response = res["rows"].filter(
            (d) => d.length && d[0] && d[1] && d[2] && d[3] && d[4] && d[5]
          );

          if (response.length === 0) return;

          var heading = response[0].map((e) => e.toLowerCase().trim());
          // remove heading
          var data = response.slice(1, response.length);

          const getIndex = (string) => {
            return heading.indexOf(string);
          };

          let security_index =
            getIndex("security name") === -1
              ? getIndex("security")
              : getIndex("security name");
          let symbol_index = getIndex("symbol");
          let fund_type_index = getIndex("fund type");
          let classification_index = getIndex("classification");
          let asset_class_index = getIndex("asset class");
          let style_index = getIndex("style");
          let core_allocation_index = getIndex("allocation");

          // getting which column has error
          const getStatus = () => {
            if (security_index === -1) {
              setValue("security");
              return;
            } else if (symbol_index === -1) {
              setValue("symbol");
              return;
            } else if (fund_type_index === -1) {
              setValue("fund type");
              return;
            } else if (classification_index === -1) {
              setValue("classification");
              return;
            } else if (asset_class_index === -1) {
              setValue("asset class");
              return;
            } else if (style_index === -1) {
              setValue("style");
              return;
            } else if (core_allocation_index === -1) {
              setValue("allocation");
              return;
            }
          };
          const setValue = (name) => {
            this.setState({
              upload_errorName: name,
            });
          };
          getStatus();

          let current =
            (heading[security_index] === "security name" ||
              heading[security_index] === "security" ||
              security_index !== -1) &&
            (heading[symbol_index] === "symbol" || symbol_index !== -1) &&
            (heading[fund_type_index] === "fund type" ||
              fund_type_index !== -1) &&
            (heading[classification_index] === "classification" ||
              classification_index !== -1) &&
            (heading[asset_class_index] === "asset class" ||
              asset_class_index !== -1) &&
            (heading[style_index] === "style" || style_index !== -1) &&
            (heading[core_allocation_index] === "allocation" ||
              core_allocation_index !== -1);

          if (current) {
            if (heading.length > 0 && current) {
              let arr = [];

              for (let i = 0; i < data.length; i++) {
                let obj = {};
                obj.fund_name = data[i][security_index];
                obj.symbol = data[i][symbol_index];
                obj.new_fund_type = data[i][fund_type_index];
                obj.new_classification = data[i][classification_index];
                obj.fund_asset_class_focus = data[i][asset_class_index];
                obj.new_style = data[i][style_index];
                obj.val = data[i][core_allocation_index]
                  ? data[i][core_allocation_index]
                  : null;

                arr.push(obj);
              }

              let cashFind = arr.filter(
                (d) => d.fund_name.toLowerCase() === "cash"
              );

              if (cashFind.length === 0) {
                let obj = {
                  fund_name: "Cash",
                  symbol: "IQCASH",
                  new_fund_type: "Cash",
                  new_classification: "Cash",
                  fund_asset_class_focus: "Cash",
                  new_style: "Cash",
                  val: 0,
                  date: new Date(),
                };
                let ar = [obj, ...arr];
                // setUniverseLitePortfolio(ar);
                // this.setState({
                //   data: ar,
                //   showAddRowModel: false,
                // });
                // this.props.setAnalyzeMergedData(ar);
                this.setState({ resetOnChangeInput: true });
                setTimeout(
                  () => this.setState({ resetOnChangeInput: false }),
                  100
                );
                document.getElementById("upload_iqcio_mymodels").value = "";

                // setting limits data
                this.setData({
                  portfolio: this.props.portfolio,
                  myUniverse: ar,
                  overRideAllocation: this.props.overRideAllocation,
                });
                let modifiedBackendParams = Helper.getLimitsDataFromSymbols(
                  ar,
                  20
                );
                this.props.setBackendParam_Analyze_Universe_limits(
                  modifiedBackendParams
                );
              } else {
                // setUniverseLitePortfolio(arr);
                // this.setState({
                //   data: arr,
                //   showAddRowModel: false,
                // });
                document.getElementById("upload_iqcio_mymodels").value = "";
                this.props.setAnalyzeMergedData(arr);
                this.setState({ resetOnChangeInput: true });
                setTimeout(
                  () => this.setState({ resetOnChangeInput: false }),
                  100
                );

                // setting limits
                let modifiedBackendParams = Helper.getLimitsDataFromSymbols(
                  arr,
                  20
                );
                this.setData({
                  portfolio: this.props.portfolio,
                  myUniverse: arr,
                  overRideAllocation: this.props.overRideAllocation,
                });
                this.props.setBackendParam_Analyze_Universe_limits(
                  modifiedBackendParams
                );
              }
            }
          }
        }
      });
    } else {
      this.setState({
        wrongXLXSFormat: true,
      });
      setTimeout(() => {
        this.setState({
          wrongXLXSFormat: false,
        });
      }, 5000);
      document.getElementById("upload_iqcio_mymodels").value = "";
    }
  };
  // ----- pannel ------------
  pannelSearchHandler = (e) => {
    let value = e.target.value.toUpperCase();
    this.setState({ pannelSearchValue: value, displayAutoCompleteOp: true });
    this.getAutoCompleteData();
  };

  getAutoCompleteData = () => {
    let { pannelSearchValue } = this.state;
    // let weight = this.state.weight;
    if (pannelSearchValue.length >= 3) {
      if (!this.state.ajax_in_progress) {
        this.setState({
          ajax_in_progress: true,
        });
        BacktestService.getAutocomplete(`${pannelSearchValue}`).then((res) => {
          this.setState({
            ajax_in_progress: false,
          });
          if (res) {
            this.setState({
              autoCompleteData: res,
            });
          }
        });
      }
    }
  };

  suggestionHandler = (e) => {
    const { autoCompleteData } = this.state;
    let index = e.target.getAttribute("index");
    let data = autoCompleteData[index];

    let pannel_fund_name = data["fund_name"];
    let pannel_asset_class = data["asset_class"];
    let pannel_classification = data["classification"];
    let pannel_symbol = data["symbol"];
    let pannel_style = data["style"];

    // clear list on selecting any option
    this.setState({
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      displayAutoCompleteOp: false,
      showPannelData: true,
    });
  };
  pannelAllocationHandler = (e) => {
    e.preventDefault();
    this.setState({
      pannelAllocationValue: e.target.value * 1,
    });
  };

  addSecurity = () => {
    const { pannelListOfDataAdded } = this.state;

    let data = Object.values(pannelListOfDataAdded);

    if (data && data.length) {
      setTimeout(function () {
        let element = document.getElementById("add_security");
        if (element) {
          element.innerHTML = `ADDED <i class="fa fa-check" aria-hidden="true" ></i>`;
        }
      }, 100);

      setTimeout(() => {
        // document.getElementById("add_security").innerHTML = `ADD`;
        this.setState({
          showSearchField: false,
          showPannelData: false,
          resetOnChangeInput: false,
        });
        let element = document.getElementById(
          `${data[0]["fund_name"].replace(regex, "")}`
        );
        if (element) {
          element.scrollIntoView({ block: "center" });
        }
      }, 800);

      this.props.addSymbol(data);
    }

    this.setState({
      pannelCheckBoxSelectedList: [],
      pannelListOfDataAdded: {},
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: "",
      // showSearchField: false,
      resetOnChangeInput: true,
    });
  };

  cancelSecurity = () => {
    this.setState({
      pannelCheckBoxSelectedList: [],
      pannelListOfDataAdded: {},
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: "",
      showSearchField: false,
      showPannelData: false,
    });
  };

  addButtonHandler = () => {
    const { showSearchField } = this.state;

    this.setState({
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: null,
      showSearchField: !showSearchField,
      // showSearchField: false,
    });
  };

  pannelRowAddHandler = () => {
    const {
      pannelListOfDataAdded,
      pannel_asset_class,
      pannel_fund_name,
      pannel_classification,
      pannel_style,
      pannel_symbol,
      pannelAllocationValue,
    } = this.state;
    let list_of_obj = { ...pannelListOfDataAdded };

    let obj = {
      fund_asset_class_focus: pannel_asset_class,
      fund_name: pannel_fund_name,
      new_classification: pannel_classification,
      new_fund_type: "",
      new_style: pannel_style,
      symbol: pannel_symbol,
      original_allocation: null,
      val: pannelAllocationValue,
    };
    list_of_obj[pannel_symbol] = obj;

    this.setState({
      pannelListOfDataAdded: list_of_obj,
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: "",
    });
  };
  pannelCheckBoxHandler = (el) => {
    console.log(el.target.getAttribute("data-id"));
    console.log(el);
    // pannelCheckBoxSelectedList
    let element = el.target.getAttribute("data-id");
    let status = el.target.checked;
    console.log(status, element);

    if (status) {
      this.setState({
        pannelCheckBoxSelectedList: [
          ...this.state.pannelCheckBoxSelectedList,
          element,
        ],
      });
    } else {
      let pannelCheckBoxSelectedList = this.state.pannelCheckBoxSelectedList.filter(
        (e) => e !== element
      );
      this.setState({
        pannelCheckBoxSelectedList: pannelCheckBoxSelectedList,
      });
    }
  };

  pannelRemoveButtonHandler = () => {
    //   x.forEach(function(el,i){
    //     if(el in obj){
    //         delete obj[el]
    //     }
    // })
    // x -- list of selected elements
    // obj data
    const { pannelCheckBoxSelectedList, pannelListOfDataAdded } = this.state;
    if (pannelCheckBoxSelectedList && pannelCheckBoxSelectedList.length > 0) {
      let data = { ...pannelListOfDataAdded };

      pannelCheckBoxSelectedList.forEach(function (el, i) {
        if (el in data) {
          delete data[el];
        }
      });

      this.setState({
        pannelListOfDataAdded: data,
        pannelCheckBoxSelectedList: [],
      });
    }
  };
  //---------------------------

  //------ exclude btn-------
  excludeButtonHandler = () => {
    this.setState({
      showExcludedSecuritiesPannel: !this.state.showExcludedSecuritiesPannel,
    });

    // pop up pannel should open and close
  };
  excludeAddHandler = () => {
    const {
      excluded_securities,
      setExcludedSecurities,
      setAnalyzeMergedData,
    } = this.props;
    const { excludedSelectedList } = this.state;
    // make merging function here
    // check if already added to main data then dont added it

    this.setState({
      showExcludedSecuritiesPannel: false,
    });

    // merging common data
    let out;
    if (excluded_securities && excluded_securities.length > 0) {
      let map = new Map();

      for (let obj of excluded_securities) {
        map.set(obj.symbol, obj);
      }
      out = [...map.values()];
    }
    // let finalData = [...out, ...this.state.finalPortfolio];
    //------------

    // add only selected in list
    let filtered_bsd_list = out.filter((el, i) =>
      excludedSelectedList.includes(i)
    );
    let finalData = [...filtered_bsd_list, ...this.state.finalPortfolio].map(
      (e) => e
    );

    // setting data
    this.setState({
      finalPortfolio: finalData,
    });

    let remaining_list_of_excluded = out.filter(
      (el, i) => !excludedSelectedList.includes(i)
    );
    setExcludedSecurities([...remaining_list_of_excluded]);
    setAnalyzeMergedData(finalData);

    // resetting tree table
    this.setState({ resetOnChangeInput: true, excludedSelectedList: [] });
    setTimeout(() => this.setState({ resetOnChangeInput: false }), 100);
  };
  excludeCancelHandler = () => {
    this.setState({
      showExcludedSecuritiesPannel: false,
      excludedSelectedList: [],
    });
  };
  excludedCheckBoxHandler = (e) => {
    let index = e.target.getAttribute("index") * 1;
    let status = e.target.checked;

    if (status) {
      this.setState({
        excludedSelectedList: [...this.state.excludedSelectedList, index],
      });
    } else {
      this.setState({
        excludedSelectedList: this.state.excludedSelectedList.filter(
          (e) => e !== index
        ),
      });
    }
    console.log(index, status);
  };
  render() {
    const {
      spinner,
      wrongXLXSFormat,
      excludedSelectedList,
      showExcludedSecuritiesPannel,
    } = this.state;
    const {
      analyze_merged_portfolio,
      excluded_securities,
      activePortfolioID,
      asset_class,
      overall_focus,
      styles,
      optimization_params,
    } = this.props;
    return (
      <div className="universe_analyze">
        <div className="universe_analyze__btgGrup">
          {excluded_securities && excluded_securities.length > 0 ? (
            <button
              className="btn iq-btn1 text-uppercase"
              onClick={(e) => this.excludeButtonHandler(e)}
            >
              Excluded securities
            </button>
          ) : null}
          <ReactToExcel
            table="myUniverse_merge_table"
            filename="myUniverse_merge_table"
            sheet="security"
            buttonText=" 📄 Download securities"
            className="btn iq-btn1 text-uppercase"
          />
          <UploadFileButton
            id="upload_iqcio_mymodels"
            icon="fa-upload"
            iconRight={false}
            text="Upload My Universe"
            eventHandler={(e) => this.xlsxHandler(e)}
          />
        </div>
        {spinner ? <Spinner /> : null}
        {wrongXLXSFormat && (
          <div className="universe_analyze__warning">
            <span>Please upload xlx/xlsx format data.</span>
          </div>
        )}

        {showExcludedSecuritiesPannel &&
        excluded_securities &&
        excluded_securities.length > 0 ? (
          <div className="universe_analyze__tablePannel">
            <TablePannel
              data={excluded_securities}
              addHandler={this.excludeAddHandler}
              cancelHandler={this.excludeCancelHandler}
              checkBoxHandler={this.excludedCheckBoxHandler}
              selectedElementLength={
                excludedSelectedList ? excludedSelectedList.length : 0
              }
            />
          </div>
        ) : null}
        {/*
        {(analyze_merged_portfolio && analyze_merged_portfolio.length > 0) ||
        (analyze_merged_portfolio &&
          analyze_merged_portfolio.length > 0 &&
          resetOnChangeInput) ? (
          <CustomTableTree
            data={analyze_merged_portfolio}
            inputFieldHandler={(e) => this.coreAllocationHandler(e)}
            checkBoxHandler={this.checkBoxHandler}
            removeRowsHandler={this.removeRowsHandler}
          />
        ) : null}
        <Fragment>
          <MultiRowPannel
            //new
            pannelListOfDataAdded={Object.values(pannelListOfDataAdded)}
            pannelCheckBoxSelectedList={pannelCheckBoxSelectedList}
            //--
            pannelSearchValue={pannelSearchValue}
            showSearchField={showSearchField}
            autoCompleteData={autoCompleteData}
            pannel_fund_name={pannel_fund_name}
            pannel_asset_class={pannel_asset_class}
            pannel_classification={pannel_classification}
            pannel_symbol={pannel_symbol}
            pannel_style={pannel_style}
            displayAutoCompleteOp={displayAutoCompleteOp}
            pannelAllocationValue={pannelAllocationValue}
            showPannelData={showPannelData}
            pannelSearchHandler={this.pannelSearchHandler}
            suggestionHandler={this.suggestionHandler}
            pannelAllocationHandler={this.pannelAllocationHandler}
            addSecurity={this.addSecurity}
            cancelSecurity={this.cancelSecurity}
            pannelRowAddHandler={this.pannelRowAddHandler}
            pannelCheckBoxHandler={this.pannelCheckBoxHandler}
            pannelRemoveButtonHandler={this.pannelRemoveButtonHandler}
          />
        </Fragment>
         <div className="universe_analyze__addrme">
          <button
            className="universe_analyze_btn text-uppercase"
            onClick={() => this.addButtonHandler()}
          >
            <i className="fa fa-plus"></i> Add Row
          </button>
          <button
            className="universe_analyze_btn text-uppercase"
            disabled={checkBoxSelectedList.length > 0 ? false : true}
            onClick={() => this.removeRowsHandler()}
          >
            remove
          </button>
        </div> */}
        <UniverseAnalyzeTreeTableHolder
          activePortfolioID={activePortfolioID}
          getScenarioShortlist={analyze_merged_portfolio}
          overall_focus={overall_focus}
          asset_class={asset_class}
          styles={styles}
          optimization_params={optimization_params}
          validate_slider_limits={true}
        />
        {analyze_merged_portfolio.length > 0 ? (
          <table id="myUniverse_merge_table">
            <thead>
              <tr>
                <th className="tw-300">Security</th>
                <th>Symbol</th>
                <th>Fund Type</th>
                <th>Classification</th>
                <th>Asset Class</th>
                <th>Style</th>
                <th>Allocation</th>
              </tr>
            </thead>
            <tbody>
              {analyze_merged_portfolio.map((element, index) => {
                return (
                  <tr key={`${element.symbol}_${index}`}>
                    <td>{element.fund_name}</td>
                    <td>{element.symbol}</td>
                    <td>{element.new_fund_type}</td>
                    <td>{element.new_classification}</td>
                    <td>{element.fund_asset_class_focus}</td>
                    <td>{element.new_style}</td>
                    <td>{element.core_allocation}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : null}
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        backendParams: {
          fund_type,
          asset_class,
          overall_focus,
          styles,
          optimization_params,
        },
        universeLite: {
          portfolio,
          analyze_merged_portfolio,
          excluded_securities,
        },
        risk: { activePortfolioID },
      },
    },
    iqciolive: { myUniverse, overRideAllocation },
  }) => ({
    fund_type,
    asset_class,
    overall_focus,
    styles,
    optimization_params,
    portfolio,
    myUniverse,
    overRideAllocation,
    analyze_merged_portfolio,
    excluded_securities,
    activePortfolioID,
  }),
  (dispatch) => ({
    setAnalyzeMergedData: (payload) =>
      dispatch({
        type: "SET_ANALYZE_MERGED_PORTFOLIOS",
        payload,
      }),
    // setting backend params data
    setBackendParam_Analyze_Universe_limits: (payload) =>
      dispatch({
        type: "SET_BACKENDPARAMS_SECURITY_UNIVERSE_LIMITS_DATA",
        payload,
      }),

    addSymbol: (payload) =>
      dispatch({ type: "ADD_ANALYZE_MERGED_PORTFOLIOS", payload }),

    setIQCIOliveMyUniverse: (payload) =>
      dispatch({
        type: "SET_IQCIO_LIVE_MY_UNIVERSE",
        payload,
      }),
    setExcludedSecurities: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_EXCLUDED_SECURITIES",
        payload,
      }),
  })
)(UniverseAnalyze);



// WEBPACK FOOTER //
// ./src/components/pages/Create/Universe.Analyze.jsx